import React from 'react';

export interface TextSummaryBoxProps {
  title?: string;
  items?: string[];
  children?: React.ReactNode;
}

export const TextSummaryBox: React.FC<TextSummaryBoxProps> = ({
  title,
  items,
  children,
}) => {
  return (
    <div className="flex-1 pt-7 pb-6 w-full bg-white rounded-3xl border border-violet-100 border-solid lg">
      {title && (
        <div className="pl-9 w-full text-lg font-semibold leading-loose text-zinc-800 max-md:max-w-full max-md:pl-5">
          {title}
        </div>
      )}
      <div className="flex flex-row flex-wrap gap-4 gap-x-9 items-stretch px-4 mt-5 w-full rounded-2xl md:px-9 max-md:max-w-full">
        {items &&
          items.length > 0 &&
          items.map((item, index) => (
            <div
              key={index}
              className="flex h-full flex-1 shrink basis-0 items-start gap-3.5 md:w-1/2 md:min-w-[300px] min-w-full"
            >
              <div className="w-4 pt-1.5 min-w-[20px]">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/432f652456aebd9fd6aa26998f7a7eff0f619409?placeholderIfAbsent=true"
                  className="aspect-[1.07] w-4 object-contain"
                  alt=""
                />
              </div>
              <div className="flex-1 w-full text-base leading-6 rounded-none md:min-w-60 text-zinc-800">
                {item}
              </div>
            </div>
          ))}
        {children}
      </div>
    </div>
  );
};
